import React, { useState } from "react";
import styled from "styled-components";
import DetailsHeader from "../../atoms/DetailsHeader/DetailsHeader";
import Price from "../../atoms/Price/Price";
import Availability from "../../molecules/Availability/Availability";
import Buy from "../Buy/Buy";
import { LOC_EU, PRIMARY } from "../../../vars/vars";

const getPrice = (part) => part.price.prices[LOC_EU].grossprice;
const isVatIncluded = (part) => {
  const candidate = part && part.price && part.price.prices[LOC_EU];
  return candidate.grossprice !== candidate.price;
};
const getAvl = (part) => {
  const location = part.available.find(({ location }) => location === LOC_EU);
  const manufacturer = part.available.find(
    ({ location }) => location === "manufacturer"
  );
  return {
    location: (location && location.quantityavailable) || 0,
    manufacturer:
      (manufacturer &&
        location.specialbackorder &&
        manufacturer.quantityavailable) ||
      0,
  };
};

const isSpecialOrder = (part) => {
  const candidate = part.available.find(({ location }) => location === LOC_EU);
  return candidate && candidate.stockcategory !== "stockeditem";
};

const ProductDetails = ({ part, addHandler, buttonText, enquiryHandler }) => {
  const [quantity, setQuantity] = useState(1);

  return (
    <section>
      <DetailsHeader text={part.description + " " + part.name} />
      <PurchaseArea>
        <Price vat={getPrice(part)} isVatIncluded={isVatIncluded(part)} />
        {localStorage.getItem("consent") === "true" ? (
          <Buy
            buttonText={buttonText}
            availability={getAvl(part)}
            record={part.id}
            addHandler={addHandler}
            enquiryHandler={enquiryHandler}
            max={getAvl(part).location + getAvl(part).manufacturer}
            changeQuantity={(e) => setQuantity(e)}
          />
        ) : (
          <NoCookieConsent>
            In order to purchase, please refresh the page and accept the cookie
            policy
          </NoCookieConsent>
        )}
      </PurchaseArea>
      <Availability availability={getAvl(part)} quantity={quantity} />
      {isSpecialOrder(part) && <SpecialOrder>Special Order Item</SpecialOrder>}
    </section>
  );
};

export default ProductDetails;

const PurchaseArea = styled.div`
  display: flex;
  justify-content: space-between;
  padding: 10px 0;
  flex-direction: column;

  @media screen and (min-width: 576px) {
    flex-direction: row;
  }
`;

const NoCookieConsent = styled.div`
  border: 2px solid ${PRIMARY};
  border-radius: 10px;
  padding: 10px;
  font-size: 12px;
`;

const SpecialOrder = styled.div`
  font-family: "Open Sans", sans-serif;
  margin-top: 10px;
  font-size: 12px;
  font-weight: 600;
  color: #333333;
`;
